import React from 'react'
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import {
    Button,
    CircularProgress,
    Dialog,
    DialogContent,
    Divider,
    Grid,
    Link,
    MobileStepper,
    Step,
    StepLabel,
    Stepper,
    Typography,
    withStyles,
} from "@material-ui/core";
import { Close, NavigateBefore, NavigateNext } from '@material-ui/icons'
import { clear_appointment_data, receive_devices } from "../../../apis/redux/fetchActions";
import AddDevicesStep from "../../steps/AddDevices/AddDevicesStep";
import ScheduleAppointmentStep from "../../steps/ScheduleAppointment/ScheduleAppointmentStep";
import APIService from '../../../apis/amplify/APIService';
import { styles } from './styles';
import AddressStep from "../../steps/Address/AddressStep";
import SummaryStep from "../../steps/Summary/SummaryStep";
import WellDoneStep from "../../steps/WellDone/WellDoneStep";
import PaymentStep from "../../steps/Payment/PaymentStep";
import CustomLink from "../../../components/CustomLink";
import { parseAppointmentData } from "../../../util";
import Notification, { ERROR_TYPE, NActionButton, SUCCESS_TYPE } from "../../../components/Notification";
import { errorBundaryHOC } from "../../../components/ErrorBoundary";
import PathErrorPage from "../../../screens/PathError/index";

class WizzardContainer extends React.Component {

    steps = ['Add Devices', 'Address', 'Schedule', 'Select Card', 'Summary'];

    constructor(props) {
        super(props);
        this.state = {
            existingDeviceId: -1,
            addingDeviceStep: 0,
            activeStep: 0,
            selectedDeviceId: 0,
            selectedColorDevice: 0,
            cantAdd: true,
            pendingAddDevice: null,
            pendingService: 1,
            addAddressDialogOpen: false,
            tabIndex: 0,
            nextButtonCaption: 'NEXT',
            addDeviceIssuesDialogOpen: false,
            addDeviceDialogOpen: false,
            selectColorDeviceDialogOpen: false,
            gettingIssuesLoadingDialogOpen: false,
            registeringAppointment: false,
            snackBarOpen: false,
            snackBarText: '',
            notifySuccess: true,
        };
    }

    isStepCompleted(step) {
        const stepIndex = this.getStepIndex();
        if (step > stepIndex)
            return false;
        else if (step === stepIndex)
            return true;
        else if (step < stepIndex)
            return true;
    }

    componentDidMount() {
        if (!this.state.activeStep && window.location.pathname !== "/fix/devices") {
            this.props.history.replace("/fix/devices");
            this.setState({ activeStep: 0 });
        }
        this.removeHistoryListener = this.props.history.listen(() => {
            this.setState({ activeStep: this.getStepIndex() });
        });
    }

    componentWillUnmount(){
        this.removeHistoryListener();
    }

    getStepIndex() {
        const pathName = window.location.pathname;
        const fixPath = pathName.split("/")[2];
        switch (fixPath) {
            case "devices":
                return 0;
            case "address":
                return 1;
            case "schedule":
                return 2;
            case "payment":
                return 3;
            case "summary":
                return 4;
            case "done":
                return 5;
            default:
                return;
        }
    }

    nextStep() {
        const stepIndex = this.getStepIndex();
        switch (stepIndex + 1) {
            case 1: {
                this.props.history.push("/fix/address");
                break;
            }
            case 2: {
                this.props.history.push("/fix/schedule");
                break;
            }
            case 3: {
                this.props.history.push("/fix/payment");
                break;
            }
            case 4: {
                this.props.history.push("/fix/summary");
                break;
            }
            case 5: {
                this.props.history.push("/fix/done");
                break;
            }
            default:
                break;
        }
    }

    backStep() {
        const stepIndex = this.getStepIndex();
        switch (stepIndex - 1) {
            case 0: {
                this.props.history.push("/fix/devices");
                break;
            }
            case 1: {
                this.props.history.push("/fix/address");
                break;
            }
            case 2: {
                this.props.history.push("/fix/schedule");
                break;
            }
            case 3: {
                this.props.history.push("/fix/payment");
                break;
            }
            case 4: {
                this.props.history.push("/fix/summary");
                break;
            }
            case 5: {
                this.props.history.push("/fix/done");
                break;
            }
            default:
                break;
        }
    }

    handleNext = event => {
        if (event !== null)
            if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
                return;
            }
        this.nextStep();
        this.setState({ nextButtonCaption: 'NEXT' });
    };

    handleBack = event => {
        if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
            return;
        }
        this.backStep();
        this.setState({ nextButtonCaption: 'NEXT' });
    };

    getRenderComponentByStep() {
        const pathName = window.location.pathname;
        const fixPath = pathName.split("/")[2];
        switch (fixPath) {
            case "devices":
                return (<AddDevicesStep history={this.props.history}/>);
            case "address":
                return (<AddressStep history={this.props.history}/>);
            case "schedule":
                return (<ScheduleAppointmentStep history={this.props.history}/>);
            case "payment":
                return (<PaymentStep history={this.props.history}/>);
            case "summary":
                return (<SummaryStep history={this.props.history}
                                     registerAppointment={() => this.registerAppointment()}
                                     registeringAppointment={this.state.registeringAppointment}/>);
            case "done":
                return (<WellDoneStep history={this.props.history} newAppointment={() => this.newAppointment()}/>);
            default: {
                return <PathErrorPage redirect={false} history={this.props.history}/>
            }
        }
    }

    disableNextButton() {
        if (this.state.activeStep === 0)
            return !this.props.hasDevices;
        else if (this.state.activeStep === 1)
            return !this.props.hasAddress;
        else if (this.state.activeStep === 2)
            return !this.props.hasSchedule;
        else if (this.state.activeStep === 3) {
            return !this.props.hasPayment;
        }
        return true;
    }

    newAppointment() {
        this.props.actions.clearAppointmentData();
        this.props.history.replace("/fix/devices")
    }

    async registerAppointment() {
        this.setState({ registeringAppointment: true });
        const appointmentData = parseAppointmentData(this.props);
        const {ok} = await APIService.registerAppointment(appointmentData);
        if (ok) {
            this.setState({registeringAppointment: false,});
            this.handleNext(null);
        } else {
            this.setState({
                registeringAppointment: false,
                snackBarOpen: true,
                notifySuccess: false,
                snackBarText: 'An error has occurred when registering the appointment.'
            });
        }
    }

    getStepTitle() {
        if (this.state.activeStep !== 5) {
            if (this.state.activeStep === 0)
                return 'DEVICES TO REPAIR';
            else return this.steps[this.state.activeStep].toUpperCase()
        }
    }

    render() {
        const { classes } = this.props;
        const {registeringAppointment, activeStep, nextButtonCaption, snackBarOpen, notifySuccess, snackBarText} = this.state;
        return (
            <div>

                <Dialog open={registeringAppointment}>
                    <DialogContent>
                        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                            <CircularProgress/>
                            <Typography variant='h6' color={"primary"} style={{marginTop: '20px'}}>
                                Registering appointment...
                            </Typography>
                        </div>
                    </DialogContent>
                </Dialog>

                <div className={classes.paperDiv} style={{display: (activeStep === 5) && 'none'}}>
                    <Grid container>
                        <Typography align='center' variant='subtitle1'
                                    style={{ marginLeft: 'auto', marginRight: 'auto', fontWeight: 'bold' }}
                                    className={classes.mobileStepper}>
                            {this.getStepTitle()}
                        </Typography>
                        <Grid item xs={12} sm={12} xl={12} md={12} lg={12} className={classes.paper}>
                            <Stepper alternativeLabel activeStep={this.state.activeStep}
                                     className={classes.desktopStepper}>
                                {this.steps.map((label, index) => {
                                    const stepProps = {};
                                    if (this.isStepCompleted(index)) {
                                        stepProps.completed = true;
                                    }
                                    return (
                                        <Step key={label} {...stepProps}>
                                            <StepLabel className="steepLabel">{label}</StepLabel>
                                        </Step>
                                    );
                                })}
                            </Stepper>

                            <MobileStepper steps={this.steps.length} activeStep={this.getStepIndex()} position="static"
                                           className={classes.mobileStepper}
                                           backButton={
                                               <Button size="small" onClick={this.handleBack}
                                                       style={{visibility: (activeStep === 0) && 'hidden'}}>
                                                   <NavigateBefore/>{"Back"}
                                               </Button>
                                           }
                                           nextButton={
                                               <Button size="small" onClick={this.handleNext}
                                                       disabled={this.disableNextButton()}
                                                       style={{visibility: (activeStep === 4 || activeStep === 5) ? 'hidden' : 'visible'}}>
                                                   Next
                                                   <NavigateNext
                                                       style={{visibility: (activeStep === 4 || activeStep === 5) ? 'hidden' : 'visible'}}/>
                                               </Button>
                                           }
                            />
                        </Grid>
                    </Grid>
                    <Divider className={classes.mobileStepperDivider}/>
                </div>

                <div className={classes.componentDiv}>
                    {this.getRenderComponentByStep()}
                </div>

                <div className={classes.divider} style={{display: (activeStep === 5) && 'none'}}>
                    <Divider variant='fullWidth'/>
                </div>
                <div className={classes.bottomButtons} style={{display: (activeStep === 5) && 'none', marginTop: 15}}>
                    <span className={classes.desktopButtons}>
                        <Link onClick={this.handleBack} color="secondary" underline='hover'
                              style={{ display: (activeStep === 6 || activeStep === 0) ? 'none' : 'inline' }}>
                        PREVIOUS
                    </Link>
                    </span>
                    <div style={{ flexGrow: 1 }}/>
                    <CustomLink onClick={this.handleNext} disabled={this.disableNextButton()}
                                className={classes.desktopButtons}
                                hidden={activeStep === 4 || activeStep === 5}>
                        {nextButtonCaption}
                    </CustomLink>
                    <Button color='secondary' variant='contained' className={classes.desktopButtons}
                            disabled={this.state.registeringAppointment}
                            onClick={this.registerAppointment.bind(this)}
                            style={{display: (activeStep !== 4) && 'none'}}>
                        REGISTER APPOINTMENT <CircularProgress size={20} id='progress'
                                                               style={{display: registeringAppointment !== true && 'none'}}/>
                    </Button>
                </div>

                <Notification open={snackBarOpen}
                              type={notifySuccess ? SUCCESS_TYPE : ERROR_TYPE}
                              ActionButton={
                                  <NActionButton key="close" ariaLabel="close"
                                                 onClick={() => this.setState({snackBarOpen: false})}>
                                      <Close/>
                                  </NActionButton>}
                              onClose={() => this.setState({snackBarOpen: false})}>
                    {snackBarText}
                </Notification>

            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
        devices: state.devices,
        appointmentData: state.appointmentData,
        hasDevices: state.appointmentData.items.length > 0,
        hasAddress: !!state.appointmentData.appointment_address,
        hasSchedule: !!state.appointmentData.appointment_hour_slot_id,
        hasPayment: !!(state.appointmentData.payment && state.cardsList && state.cardsList.length > 0),
    }
};

const mapDispatchToProps = dispatch => ({
    actions: bindActionCreators({
        receiveDevices: receive_devices,
        clearAppointmentData: clear_appointment_data,
    }, dispatch)
});

const WizzardContainerStyled = withStyles(styles)(WizzardContainer);
export default connect(mapStateToProps, mapDispatchToProps)(errorBundaryHOC((WizzardContainerStyled)));
